import { z } from 'zod';

// Documentos legales y aceptaciones (RF-09.01 a RF-09.03).

export const legalDocumentKindSchema = z.enum(['terms', 'private_voices']);

export const legalDocumentSchema = z
  .object({
    kind: legalDocumentKindSchema,
    version: z.string(),
    title: z.string(),
    /** URL estable de esta versión, relativa al origen de la web. */
    path: z.string(),
    sha256: z.string(),
    requiresAcceptance: z.boolean(),
    publishedAt: z.iso.datetime(),
  })
  .meta({ id: 'LegalDocument' });

export const legalDocumentsSchema = z.object({ items: z.array(legalDocumentSchema) });

export const legalAcceptRequestSchema = z.object({
  kind: legalDocumentKindSchema,
  /** La versión que la persona ha visto: si ya no es la vigente, se rechaza. */
  version: z.string().max(40),
});

export const legalAcceptanceSchema = legalDocumentSchema.extend({
  acceptedAt: z.iso.datetime(),
  source: z.enum(['signup', 'login', 'legacy_v1']),
});

export const myLegalSchema = z.object({
  /** Versiones vigentes que la cuenta debe aceptar antes de operar (RF-09.03). */
  pending: z.array(legalDocumentSchema),
  acceptances: z.array(legalAcceptanceSchema),
});
